$(document).ready(function () {
    const categoryTabs = $('#category-tabs .nav-link');
    const galleryItems = $('.gallery-item');

    function filterGallery(category) {
        let delay = 0;

        galleryItems.each(function () {
            const item = $(this);
            const itemCategory = item.data('category');

            if (category === 'all' || itemCategory === category) {
                // Show item with staggered animation
                setTimeout(() => {
                    item.stop(true, true).fadeIn(100).removeClass('scaled');
                }, delay);
                // delay += 50; // Adjust delay as needed for smoother effect
            } else {
                // Hide item with staggered animation
                setTimeout(() => {
                    item.stop(true, true).addClass('scaled').fadeOut(100);
                }, delay);
                // delay += 50;
            }
        });
    }

    // Event listener for category tabs
    categoryTabs.on('click', function (event) {
        event.preventDefault();
        const selectedCategory = $(this).data('category');

        // Update active class on tabs
        categoryTabs.removeClass('active');
        $(this).addClass('active');

        // Filter the gallery items
        filterGallery(selectedCategory);
    });

    // Initial filter to show all items
    filterGallery('all');
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/gallery.js